export const getFlag = (countryCode) => {
  try {
    return require(`../assets/flags/${countryCode}.svg`);
  } catch (error) {
    console.error("Flag not found:", countryCode);
    return null;
  }
};